// export const API_ROOT = 'http://localhost:8555'
// export const API_ROOT = 'http://10.0.0.20:8555'
// export const API_ROOT = 'http://10.0.0.22:8555'
// export const SOCKET_API = 'ws://10.0.0.26:5577'
// export const API_ROOT = 'http://10.0.0.26:5577'
export const SOCKET_API = 'wss://apidev.zizbeyjobs.com'
export const API_ROOT = 'https://apidev.zizbeyjobs.com'
export const IS_DESKTOP_APP = false
  